import {
    LIST_SERVERS,
    LIST_SERVERS_SUCCESS,
    LIST_SERVERS_ERROR,
    ADD_SERVERS,
    SAVE_SERVERS,
    SAVE_SERVERS_SUCCESS,
    SAVE_SERVERS_ERROR,
    DELETE_SERVERS,
    DELETE_SERVERS_SUCCESS,
    DELETE_SERVERS_ERROR,
    EDIT_SERVERS,
    UPDATE_SERVERS,
    UPDATE_SERVERS_SUCCESS,
    UPDATE_SERVERS_ERROR
} from '../types';

import clienteAxios from '../config/axios';
import authToken from '../config/token';

import serversData from '../data/servers';
import { ErrorMessage, SuccessMessage, WaitingMessage } from '../components/extras/toastMessages';
import { MSG_CREATE_SUCCESS, MSG_UPDATE_SUCCESS, MSG_DELETING, MSG_DELETE_SUCCESS } from '../constants/messages';
import Swal from 'sweetalert2';

const controller = 'fuero';

//LISTAR SERVERS
export function listServersAction(params) {
    return async (dispatch) => {
        //Inicializo
        dispatch( listServers() );
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.get(`/${controller}`, { params });
            //Obtengo los datos
            const servers = response.data;
            //const servers = serversData;
            //Llamo al dispatch
            dispatch( listServersSuccess(servers.content) );
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( listServersError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const listServers = () => ({
    type: LIST_SERVERS,
    payload: true
});

const listServersSuccess = servers => ({
    type: LIST_SERVERS_SUCCESS,
    payload: servers
});

const listServersError = error => ({
    type: LIST_SERVERS_ERROR,
    payload: error
});

//ADD SERVER
export function addServersAction(showForm) {
    return (dispatch) => {
        //Inicializo
        dispatch( addServers(false) );
        //Abro el formulario
        showForm();
    }
}

const addServers = isEdit => ({
    type: ADD_SERVERS,
    payload: isEdit
});

//SAVE SERVER
export function saveServersAction(server, handleClose) {
    return async (dispatch) => {
        //Inicializo
        dispatch( saveServers() );
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.post(`/${controller}`, server);
            //Obtengo los datos
            //const res = response.data;
            //Llamo al dispatch
            dispatch( saveServersSuccess(response.data) );
            //Cierro la ventana
            handleClose();
            //Mensaje
            SuccessMessage(MSG_CREATE_SUCCESS);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( saveServersError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const saveServers = () => ({
    type: SAVE_SERVERS,
    payload: true
});


const saveServersSuccess = server => ({
    type: SAVE_SERVERS_SUCCESS,
    payload: server
});

const saveServersError = error => ({
    type: SAVE_SERVERS_ERROR,
    payload: error
});

//EDIT SERVER
export function editServersAction(server, showForm) {
    return async (dispatch) => {
        //Inicializo
        dispatch( editServers(server) );
        //Abro el formulario
        showForm();
    }
}

const editServers = server => ({
    type: EDIT_SERVERS,
    payload: server
});

//UPDATE SERVER
export function updateServersAction(server, handleClose) {
    return async (dispatch) => {
        //Inicializo
        dispatch( updateServers() );
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.put(`/${controller}/${server.id}`, server);
            //Obtengo los datos
            //const res = response.data;
            //Llamo al dispatch
            dispatch( updateServersSuccess(response.data) );
            //Cierro la ventana
            handleClose();
            //Mensaje
            SuccessMessage(MSG_UPDATE_SUCCESS);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( updateServersError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const updateServers = () => ({
    type: UPDATE_SERVERS,
    payload: true
});

const updateServersSuccess = server => ({
    type: UPDATE_SERVERS_SUCCESS,
    payload: server
});

const updateServersError = error => ({
    type: UPDATE_SERVERS_ERROR,
    payload: error
});

//DELETE SERVER
export function deleteServersAction(server) {
    return async (dispatch) => {
        //Inicializo
        dispatch( deleteServers() );
        //Mensaje de Espera
        WaitingMessage(MSG_DELETING);
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.delete(`/${controller}/${server.id}`);
            //Obtengo los datos
            //const res = response.data;
            //Llamo al dispatch
            dispatch( deleteServersSuccess(server.id) );
            //Oculto espera
            Swal.close();
            //Mensaje
            SuccessMessage(MSG_DELETE_SUCCESS);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( deleteServersError(data) );
            //Oculto espera
            Swal.close();
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const deleteServers = () => ({
    type: DELETE_SERVERS,
    payload: true
});

const deleteServersSuccess = server => ({
    type: DELETE_SERVERS_SUCCESS,
    payload: server
});

const deleteServersError = error => ({
    type: DELETE_SERVERS_ERROR,
    payload: error
});